// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Sggc","selected":"Chip_selected__1Gmhe"};